<template>
    <div>
      <p class="help" v-if="regs.length === 0">{{$t("absence.noApp")}}</p>
      <table v-else class="table is-fullwidth">
        <thead>
          <tr>
            <th>{{$t("settings.project")}}</th>
            <th>{{$t("settings.date")}}</th>
            <th>{{$t("settings.time")}}</th>
            <th>
              {{$t("input.approve")}}
              <!-- <span class="field is-grouped" v-if="regs.length > 0">
                  <p class="control">
                    <a @click="approveAllRegistrations()" class="button is-small is-primary">Godkend alle</a>
                  </p>
                <p class="control">
                  <a @click="rejectAllRegistrations()" class="button is-small is-danger">Afvis alle</a>
                </p>
              </span> -->
            </th>
          </tr>
        </thead>
        <tbody v-for="(monthlyReg, index) in regsGroupedMonthly" v-if="filterApprovedMonth(monthlyReg)" v-bind:key="monthlyReg['.key']">
          <tr>
            <th style="min-width:140px">
              <a @click="expandMonth(index)" :title="index">
                <span class="icon">
                  <font-awesome-icon :icon="['fas', 'chevron-right']" v-if="!showMonth(index)"></font-awesome-icon>
                  <font-awesome-icon :icon="['fas', 'chevron-down']" v-if="showMonth(index)"></font-awesome-icon>
                </span>
                {{ returnMonthName(index) }}
              </a>
            </th>
            <td></td>
            <td>{{ sumMonthlyTime(index) }} </td>
            <td>
              <span class="field is-grouped" v-if="regs.length > 0">
                  <p class="control">
                    <a @click="approveMonthlyRegistrations(index)" class="button is-small is-primary">{{$t("input.appMonth")}}</a>
                  </p>
                <p class="control">
                  <a @click="rejectMonthlyRegistrations(index)" class="button is-small is-danger">{{$t("input.rejMonth")}}</a>
                </p>
              </span>
            </td>
          </tr>
          <tr v-for="reg in regs" v-if="showMonth(index) && !reg.isApproved && returnMonthNo(reg.date) == index" v-bind:key="reg['.key']">
            <td>
              <strong>{{returnProjectDescription(reg.project, reg.isCustomProject)}} <span v-if="!reg.isCustomProject">({{ reg.project }})</span></strong>
              <br>
              <small>{{ returnProjectLineDescription(reg.project, reg.projectLine, reg.isCustomProject) }}</small>
            </td>
            <td>{{ moment(reg.date) }}</td>
            <td>{{reg.time}}</td>
            <td>
                <div class="field is-grouped">
                  <p class="control">
                    <a @click="approveRegistration(reg)" class="button is-small is-primary">{{$t("input.approve")}}</a>
                  </p>
                  <p class="control">
                    <a @click="rejectRegistration(reg['.key'])" class="button is-small is-danger">{{$t("input.reject")}}</a>
                  </p>
                  <p class="control" v-if="showcomment(reg.date, reg['.key'])">
                    <a @click="showOrHideComment(reg.date)" class="button is-small is-warning">
                      <span v-if="displayComment == reg.date">{{$t("input.hideComment")}}</span>
                      <span v-else>{{$t("input.viewComment")}}</span>
                    </a>
                  </p>
              </div>
              <div v-if="displayComment == reg.date">
                <ul>
                  <li v-for="comment in showcomment(reg.date, reg['.key'])">
                    <font-awesome-icon :icon="['far', 'comments']"></font-awesome-icon>
                    {{ comment.text }}
                  </li>
                </ul>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
</template>

<script>
import firebase from '@/firebase'
import moment from 'moment'
import _ from 'lodash'

export default {
  name: 'TimeRegistrations',
  props: {
    userId: String
  },
  data: function() {
    return {
      monthArray: [],
      displayComment: false,
    }
  },
  firebase: function() { 
    const tenantid = JSON.parse(localStorage.getItem('profile')).tenantid;
    const userid = JSON.parse(localStorage.getItem('profile')).user_id;
    return {
        comments: {
            source: firebase.database().ref('/organisations/' + tenantid + '/registrationsComment/'),
        },
        regs: {
            source: firebase.database().ref('/organisations/' + tenantid + '/registrations/' + this.userId).orderByChild('sentForApproval').equalTo(true),
        },
        absence: {
            source: firebase.database().ref('/organisations/' + tenantid + '/registrationsAbsence/' + this.userId).orderByChild('sentForApproval').equalTo(true),
        },
        regsERP: {
            source: firebase.database().ref('/organisations/' + tenantid + '/ERPrequests').limitToFirst(1),
        },
        allProjects: {
            source: firebase.database().ref('/organisations/' + tenantid + '/JobList'),
        },
        allProjectLines: {
            source: firebase.database().ref('/organisations/' + tenantid + '/JobTaskLines').orderByChild('favorite'),
        },
        orgSettings: {
            source: firebase.database().ref('/organisations/' + tenantid + '/settings'),
            asObject: true,
        },
        orgUsers: {
            source: firebase.database().ref('/organisations/' + tenantid + '/users').orderByChild('adminCanEdit/active').equalTo(true),
            asObject: false,
        },
        orgResources: {
            source: firebase.database().ref('/organisations/' + tenantid + '/ResourceList').orderByChild('type').equalTo('Person'),
            asObject: false,
        },
    }
  },
  computed: {
    regsGroupedMonthly() {
        const regsSortedDesc = _.orderBy(this.regs, ['date'], ['desc'])
        const unsortedMonthlyRegs = _.groupBy(regsSortedDesc, (o) => {
            return moment(o.date).format('YYYY-MM');
        })
        return unsortedMonthlyRegs
    },
  },
  methods: {
    showOrHideComment(date) {
      if(!this.displayComment || this.displayComment !== date) {
        this.displayComment = date
      } else {
        this.displayComment = false
      }
    },
    showcomment(date, key) {
      const userComments = _.filter(this.comments, {'.key': this.userId})
      const commentsOnDate = _.filter(userComments[0], {'date': date})
      if(commentsOnDate.length > 0) {
        return commentsOnDate
      } else {
        return false
      }
    },
    sumMonthlyTime(yearMonth) {
      const self = this;
      const filteredRegs = _.filter(this.regs, function(o) {
        if(moment(o.date).format('YYYY-MM') == yearMonth && (o.isApproved === false || !o.isApproved)) {
          return o;
        }
      })
      return _.sumBy(filteredRegs, 'time')
    },
    filterApprovedMonth(regs) {
      const containsOnlyApproved = _.flatMap(regs, 'isApproved')
      return _.includes(containsOnlyApproved, false)
    },
    showMonth(index) {
      if(_.includes(this.monthArray, index)) {
        return true;
      } else {
        return false;
      }
    },
    expandMonth(index) {
      if(_.includes(this.monthArray, index)) {
        for (var i=this.monthArray.length-1; i>=0; i--) {
            if (this.monthArray[i] === index) {
                this.monthArray.splice(i, 1);
            }
        }
      }  else {
        this.monthArray.push(index);
      }
    },
    returnMonthNo(date) {
      return moment(date).format('YYYY-MM')
    },
    returnMonthName(yearMonth) {
        moment.locale(this.$i18n.locale)
        return moment(yearMonth).format('MMMM')
    },
    rejectMonthlyRegistrations(yearMonth) {
      const self = this;
      const filteredRegs = _.filter(this.regs, function(o) {
        if(moment(o.date).format('YYYY-MM') == yearMonth) {
          return o;
        }
      })
      _.forEachRight(filteredRegs, function(reg) {
        self.rejectRegistration(reg['.key'])
      }) 
    },
    approveMonthlyRegistrations(yearMonth) {
      const self = this;
      const filteredRegs = _.filter(this.regs, function(o) {
        if(moment(o.date).format('YYYY-MM') == yearMonth) {
          return o;
        }
      })
      _.forEach(filteredRegs, function(reg) {self.approveRegistration(reg)})
    },
    approveAllRegistrations() {
      const self = this;
      _.forEach(this.regs, function(reg) {self.approveRegistration(reg)})
    },
    rejectAllRegistrations() {
      const self = this;
      _.forEachRight(this.regs, function(reg) {
        self.rejectRegistration(reg['.key'])
      })
    },
    returnProjectDescription: function(projectNo, isCustom) {
      if(!isCustom) {
        const project = _.find(this.allProjects, { 'no': projectNo });
        if (project) {
          return project.description;
        } else {
          return;
        }
      } else {
        const project = _.get(this.orgSettings.customProjects, projectNo);
        if (project) {
          return project.name;
        } else {
          return;
        }
      }
    },
    returnProjectLineDescription: function(projectNo, lineNo, isCustom) {
      if(!isCustom) {
        const projectLine = _.find(this.allProjectLines, { 'no': projectNo , 'task_no': lineNo});
        if (projectLine) {
          return projectLine.description;
        } else {
          return;
        }
      } else {
        const projectLine = _.get(this.orgSettings.customProjectLines, lineNo);
        if (projectLine) {
          return projectLine.name;
        } else {
          return;
        }
      }
    },
    moment: function (date) {
      return moment(date).format('DD/MM/YYYY');
    },
    approveRegistration: function(registration) {
      const now = moment().format();
      const userid = JSON.parse(localStorage.getItem('profile')).user_id;

      this.$firebaseRefs.regs.child(registration['.key']).update({approverUID: userid, isApproved: true, timestampApproval: now})
      //push approvals to upload
      // const updates = {
      //   date: registration['date'],
      //   project: registration['project'],
      //   projectLine: registration['projectLine'],
      //   uid: registration['uid'],
      //   tenantid: registration['tenantid'],
      //   time: registration['time'],
      //   timestamp: now,
      //   timestampOrignialRegistration: registration['timestamp']
      // };
      const postingDate = moment().startOf('day').format('YYYY-MM-DD[T]HH:mm:ss[Z]');
      const documentDate = moment(registration['date']).startOf('day').format('YYYY-MM-DD[T]HH:mm:ss[Z]'); //2018-07-03T00:00:00Z
      // FIXME: resNo
      const updates = {
        description: 'Tidsregistrering',
        docNo: 'test tid',
        extDocNo: registration['.key'],
        jobNo: registration['project'],
        jobTaskNo: registration['projectLine'],
        quantity: registration['time'],
        req: 'post',
        resNo: 'JE',
        type: 'JobJournal',
        postingDate: postingDate,
        documentDate: documentDate
      }
      // push approval to ERP queue
      this.$firebaseRefs.regsERP.child(registration['.key']).update(updates)
    },
    rejectRegistration: function(regKey) {
      const updates = {sentForApproval: false, isApproved: false, isRejected: true}
      this.$firebaseRefs.regs.child(regKey).update(updates)
    },
    approveAbsence: function(registration) {
      const userid = JSON.parse(localStorage.getItem('profile')).user_id;
      const now = moment().format();
      this.$firebaseRefs.absence.child(registration['.key']).update({approverUID: userid, isApproved: true, timestampApproval: now})
      //push approvals to upload
      // const updates = {
      //   fromDate: registration['fromDate'],
      //   toDate: registration['toDate'],
      //   absence: registration['absence'],
      //   absenceMeasure: registration['absenceMeasure'],
      //   upn: registration['upn'],
      //   uid: registration['uid'],
      //   time: registration['time'],
      //   timestamp: now,
      //   timestampOrignialRegistration: registration['timestamp']
      // };
      // this.$firebaseRefs.absenceERP.child(registration['.key']).update(updates)
    },
    rejectAbsence: function(registration) {
      const updates = {sentForApproval: false, isApproved: false, isRejected: true}
      this.$firebaseRefs.absence.child(registration['.key']).update(updates)
    },
  }
}
</script>
<style scoped>
</style>
